import type { Chapter } from '@data/utils/types';

/** The report's chapter choices, in the organization's ranked order, keeping a saved chapter that has since been switched off. */
export const chapterOptions = (
  chapters: Pick<Chapter, 'role' | 'text'>[],
  savedRole?: string,
): { value: string; label: string }[] => {
  const options = chapters.map(({ role, text }) => ({ value: role, label: text }));
  if (savedRole && !options.some(option => option.value === savedRole)) {
    options.push({ value: savedRole, label: savedRole });
  }
  return options;
};
